// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3jUD2","logo":"Header_logo__1_ZSz"};